var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34003 0.187439C3.59589 0.187439 0.590027 3.21967 0.590027 6.93744C0.590027 10.6816 3.59589 13.6874 7.34003 13.6874C11.0578 13.6874 14.09 10.6816 14.09 6.93744C14.09 3.21967 11.0578 0.187439 7.34003 0.187439ZM2.27753 6.93744C2.27753 5.85638 2.6203 4.85443 3.20038 4.01068L10.2668 11.0771C9.42303 11.6572 8.42108 11.9999 7.34003 11.9999C4.5451 11.9999 2.27753 9.73236 2.27753 6.93744ZM11.4533 9.89056L4.3869 2.82416C5.23065 2.24408 6.2326 1.87494 7.34003 1.87494C10.1086 1.87494 12.4025 4.16888 12.4025 6.93744C12.4025 8.04486 12.0334 9.04681 11.4533 9.89056Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.1c5f2ab5c8daf78b39bded5b25b360a7.svg";
export { ForwardRef as ReactComponent };